import React, { useState, useEffect } from 'react';
import { TextField, Button } from '@mui/material';
import { Language } from '../../../../constants/Constants';
import { tablePrimaryButtonSx } from '../../../../styles/tableButtonStyles';

const LanguageDisplayName = ({ language, onSubmit }) => {
  const [displayName, setDisplayName] = useState(language.displayName || '');
  const [error, setError] = useState('');

  useEffect(() => {
    if (language.displayName) {
      setDisplayName(language.displayName);
    }
  }, [language]);

  const handleChange = (e) => {
    setDisplayName(e.target.value);
  };

  const handleSubmit = () => {
    if (!displayName) {
      setError(Language.displayNameError);
      return;
    }
    setError('');
    onSubmit(displayName, language.isoCode);
  };

  return (
    <div>
      <TextField
        label={Language.displayNamelabel}
        value={displayName}
        onChange={handleChange}
        error={!!error}
        helperText={error}
        fullWidth
        margin='normal'
      />
      <Button onClick={handleSubmit} variant='contained' color='primary' size='small' sx={tablePrimaryButtonSx}>
        {Language.updateDisplayNameLabel}
      </Button>
    </div>
  );
};

export default LanguageDisplayName;
